import { Component, Input } from '@angular/core';
import { AuthService } from '@app/core/services';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ConfigWindowComponent } from './config-window.component';
import { IntlService } from '@progress/kendo-angular-intl';
import { User } from '@app/core/models';


@Component({
  selector: 'config-date',
  template: `
  <div class="k-overlay" *ngIf="opened"></div>
  <kendo-window [width]="430" title="{{ label }}" *ngIf="opened" (close)="onClose()">
    <!--<div class="example-config">
      Selected range: {{ range | json }}
    </div>-->
    <form novalidate [formGroup]="form">
      <div class="example-wrapper form-detail">        
        <div class="row m0">
          <div class="col-xs-12 col-sm-12 example-col">
              <kendo-label text="Fecha:"></kendo-label>
              <kendo-textbox-container>
                <kendo-datepicker formControlName="date" [format]="'dd-MMM-yyyy'"></kendo-datepicker>
              </kendo-textbox-container>
              <div *ngIf="f.date.invalid && (f.date.dirty || f.date.touched)">                  
                <div *ngIf="f.date.errors">
                  <kendo-formerror *ngIf="f.date.errors.required">
                    Error: Campo requerido.
                  </kendo-formerror>
                </div>   
              </div>
          </div>
        </div>
      </div>
    </form>

    <div class="text-right">
        <button type="button" class="k-button" (click)="onCancel()">Cancelar</button>
        <button type="button" class="k-button k-primary ml-1" (click)="onSuccesfull()">Seleccionar</button>
    </div>
       
  </kendo-window>      
  `,
  styles: [`
    .k-textbox-container, input.k-textbox {
      width: 100%;
    }
  `]
})
export class ConfigDateComponent extends ConfigWindowComponent {

  //Variables

  // public date: Date;

  @Input() label: string = 'Seleccionar fecha';
  
  //Métodos

  constructor(protected authService: AuthService, protected intl: IntlService) {

    super(authService);

  }
  
  protected getFormGroup(user: User, dataItem?: any): FormGroup {

    return new FormGroup({
      'report': new FormControl((dataItem) ? dataItem.report: ''), 
      'date': new FormControl(new Date()),      
    });

  };

  public onSuccesfull(): void {
    
    console.log('onSuccesfull', this.form.value.date)

    this.config.emit({
      dataItem: {
        report: this.form.value.report,
        date: this.intl.formatDate(this.form.value.date, "yyyy-MM-dd")
      }
    });
    this.opened = false;

  }

}
